<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Run Task</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">

  <!-- Command list -->
  @if (runnableCommands && !commandIsRunning && !runningCommand) {
    <div>
      <table class="w-100">
        <thead>
          <tr>
            <th>Label</th>
            <th>Command</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (command of runnableCommands; track command) {
            <tr>
              <td class="w-35 py-3">{{ command.name }}</td>
              <td class="font-monospace small">{{ command.buildCommandLine() }}</td>
              <td>
                @if (!commandIsRunning) {
                  <button (click)="runTask(command)" class="btn btn-primary fw-bold">Run</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- No commands found -->
  @if (!runnableCommands) {
    <div>
      <p>No runnable tasks to execute.</p>
    </div>
  }

  <!-- A command is running -->
  @if (commandIsRunning) {
    <div>
      <p>The task is running...</p>
    </div>
  }

  @if (runningCommand) {
    <div>
      <p>The task <span class="fw-bold">{{ runningCommand.description }}</span> has run with id <span class="fw-bold">{{ runningCommand.id }}</span>.</p>
    </div>
  }

  @if (commandIsRunning || runningCommand) {
    <button (click)="refresh()" class="btn btn-primary fw-bold">Refresh</button>
  }

</div>
